import { useMemo } from "react";
import { isFunction } from "lodash";
import { useMutation } from "react-query";
import { usePunditUserContext } from "@/react/contexts";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { useChatNotification } from "@circle-react/hooks/chatsV2/useChatNotification";

interface UseMarkAllChatRoomAsReadProps {
  onSuccess?: () => void;
}

export const useMarkAllChatRoomAsRead = ({
  onSuccess,
}: UseMarkAllChatRoomAsReadProps = {}) => {
  const { currentCommunitySettings } = usePunditUserContext();
  const {
    cached_unread_chat_room_ids_enabled: isCachedUnreadChatRoomIdsEnabled,
  } = currentCommunitySettings || {};
  const { unreadChatRoomUuids = [] } = useChatNotification();

  const params = useMemo<Record<string, unknown>>(() => {
    const options: Record<string, unknown> = {};
    if (isCachedUnreadChatRoomIdsEnabled) {
      options["only_unread"] = true;
    } else {
      options["uuids"] = unreadChatRoomUuids;
    }
    return options;
  }, [isCachedUnreadChatRoomIdsEnabled, unreadChatRoomUuids]);

  const { mutateAsync: markAllChatRoomAsRead, isLoading } = useMutation(
    () =>
      reactQueryPatch(
        internalApi.chatRooms.markAllAsRead({
          params,
        }),
      ),
    {
      onSuccess: () => {
        isFunction(onSuccess) && onSuccess();
      },
    },
  );

  return { markAllChatRoomAsRead, isLoading };
};
